import { Text } from "react-native-paper";
import { useAppTheme } from "../../useAppTheme";
import Box from "../Box";
import type { CmeCreditRowData } from "./types";

type Props = {
	credit: CmeCreditRowData;
};

export const CmeCreditRow = ({ credit }: Props) => {
	const theme = useAppTheme();

	return (
		<Box
			flexDirection="row"
			alignItems="center"
			gap={16}
			paddingHorizontal={16}
			paddingVertical={8}
		>
			<Box flex={1} gap={4}>
				<Text variant="bodyMedium" style={{ fontWeight: "600" }}>
					{credit.title}
				</Text>
				<Text
					variant="bodySmall"
					style={{ color: theme.colors.onSurfaceVariant }}
				>
					{credit.typeLabel}
				</Text>
			</Box>
			<Text variant="bodyMedium" style={{ fontWeight: "600" }}>
				{credit.creditLabel}
			</Text>
		</Box>
	);
};
